module.exports = __webpack_public_path__ + "static/media/5DPO23.abea9af9.jpg";